<template>
  <div class="is-main-title">
    <div class="columns is-vcentered">
      <div class="column">
        <h2 class="title is-4 ">Convemos</h2>
      </div>
      <div class="column is-2">
        <p class="control" @click="goBack">
          <a class="button is-back">
            <b>Voltar</b>
          </a>
        </p>
      </div>
    </div>
    <h2 class="subtitle is-4 is-main-subtitle">Base de Dados</h2>
    <div class="columns">
      <div class="column is-full-bar">
        <h1 class="subtitle is-5"><b>RESULTADOS DA PESQUISA</b></h1>
      </div>
    </div>
    <div class="columns is-vcentered">
      <div class="column is-3">
        <h2 class="subtitle is-4 is-main-subtitle">Total de {{results.length}} registos</h2>
      </div>
      <div class="column">
        <div class="field addPadding">
          <span class="subtitle is-5">Lista </span>
          <input id="switchExample" type="checkbox" name="switchExample" class="switch" :checked="isMap" @click="isMap = !isMap">
          <label for="switchExample"><span class="subtitle is-5">Mapa</span></label>
        </div>
      </div>
    </div>
    <div v-if="!isMap">
      <div class="columns is-result-line is-vcentered" v-for="result in results" :value="result" :key="result.id">
        <div class="column">
          <h2 class="subtitle is-6">{{result.monastery.name}}</h2>
        </div>
        <div class="column is-2">
          <a class="button is-submit" @click="chooseMonastery(result.monastery.id)">
            ver ficha
          </a>
        </div>
      </div>
    </div>
    <monasteries-map :monasteries="results" v-else @id="chooseMonastery"></monasteries-map>
  </div>
</template>

<script>
import MonasteriesMap from "./partial/MonasteriesMap";


export default {
name: "SearchResults",
  components: {MonasteriesMap},
  props:{
    results:{
      type: Array,
    }
  },
  data: ()=>({
    isMap: false,
  }),
  methods: {
    chooseMonastery(monasteryId) {
      this.$emit('id', monasteryId)
    },
    goBack() {
      this.$emit('back');
    },
  },
  mounted() {

  },
}
</script>

<style scoped>
.is-main-title{
  margin: 0.55em;
}

.is-main-subtitle{
  padding-top: 20px;
}

.is-full-bar{
  background-color: #ded5c1;
}

.is-main-content p{
  font-size: 14px;
  text-align: justify;
  margin: 1em;
  line-height: 1.4;
}

.is-result-line{
  border-bottom: thin black solid;
  width: 80%;
}

.is-submit{
  background-color: #e8e5e0;
}

.is-back{
  background-color: #ded5c1;
}

.addPadding{
  margin-top: 26px;
}

.switch[type=checkbox]:checked+label::before, .switch[type=checkbox]:checked+label:before {
  background: #ded5c1;
}
</style>